module.exports = __webpack_public_path__ + "static/media/canon-checkout-desktop.cdf7d474.jpg";